import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLine, Overline } from "@/components/Reveal";

export default function PageHero({ image, overline, title, italic, sub, alt }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);

  return (
    <section ref={ref} data-testid="page-hero" className="relative h-[62vh] min-h-[440px] overflow-hidden flex items-end grain">
      <motion.img
        src={image}
        alt={alt || title}
        style={{ y }}
        className="absolute inset-0 w-full h-[125%] object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/55 to-background/30" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-16 w-full">
        <Overline className="mb-5">{overline}</Overline>
        <h1 className="font-heading text-5xl md:text-7xl tracking-tight leading-[1.05]">
          <MaskedLine delay={0.1}>{title}</MaskedLine>
          {italic && (
            <MaskedLine delay={0.25} className="italic text-primary">
              {italic}
            </MaskedLine>
          )}
        </h1>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="mt-6 max-w-2xl text-base md:text-lg text-foreground/80 leading-relaxed"
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
